import { Component, OnInit, HostListener, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Confidence } from "../shared/models/confidence";
import { AssessmentService } from "../shared/services/assessment.service";
import { UserService } from "../../shared/services/user.service";
import { NotificationsService } from "../../shared/services/notifications.service";
import { ViewStateService } from "../../shared/services/view-state.service";
import { Assessment } from "../shared/models/assessment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-confidence-relevance",
  templateUrl: "./confidence-relevance.component.html",
  styleUrls: ["./confidence-relevance.component.css"],
})
export class ConfidenceRelevanceComponent implements OnInit, OnDestroy {
  questionId: string;
  assessmentId: string;
  personId: string;
  confidence: Confidence;
  assessment: Assessment;
  private destroy$ = new Subject<void>();

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private assessmentService: AssessmentService,
    private notifications: NotificationsService,
    private viewState: ViewStateService
  ) {
    this.confidence = new Confidence();
  }

  ngOnInit() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    this.personId = this.userService.CurrentUser.personId;
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.questionId = params["questionId"];
      this.assessmentId = params["assessmentId"];
      this.assessment = this.assessmentService.getAssessmentObj(
        this.assessmentId
      );
    });
  }

  submitConfidence() {
    this.viewState.startLoading();
    const questionResponseId = this.assessmentService.getQuestionResponseId();
    this.assessmentService
      .submitConfidenceRelevance(this.personId, questionResponseId, this.confidence)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.viewState.stopLoading();
          this.router.navigate([
            "assessment/" +
              this.assessmentId +
              "/question/" +
              this.questionId +
              "/answer",
          ]);
        },
        (errors) => {
          this.handleServerErrorResponse(errors);
        }
      );
  }

  private handleServerErrorResponse(response) {
    if (response.status === 500)
      {this.notifications.error(
        "Unexpected Error",
        "An unexpected error occurred. Please try again or contact NBRC for assistance."
      );}
    else {
    }
    this.viewState.stopLoading();
  }

  blockCopy() {
    this.assessmentService
      .warnUser(this.personId, "copy", this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  blockCut() {
    this.assessmentService
      .warnUser(this.personId, "cut", this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeunloadHandler(event) {
    return (event.returnValue =
      "You have started question complete it first, If you leave, your will get 0 .");
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
